var exports = {
  "BN": "VoiceGridLayout.module__gridViewport___UnFBOV",
  "Om": "VoiceGridLayout.module__gridViewportCompact___UnFBOV",
  "Vg": "VoiceGridLayout.module__grid___UnFBOV",
  "ux": "VoiceGridLayout.module__gridItem___UnFBOV",
};

module.exports = exports;
